const routes = {
  HOME: "/",
  OFFER: "/offer/:id",
  PUBLISH: "/offer/publish",
  PAYMENT: "/payment",
  NOTFOUNDPAGE: "*",
};

export default routes;
